export const tablet = 600;
export const desktop = 1024;
export const desktopMedium = 1279;
